// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3228r","right":"Footer_right__1eEk0","buttons":"Footer_buttons__1zoMJ"};